import { get } from "lodash"
import classNames from "classnames"
import { TablePagination as MUITablePagination } from "@mui/material"
import Arrows from "./arrows"
import "./style.scss"

function TablePagination(props) {
  return <MUITablePagination
    {...props}
    className={classNames("components_table-pagination", get(props, "className", ""))}
    classes={{ displayedRows: "pagination-caption" }}
    ActionsComponent={Arrows}
  />
}

export default TablePagination
